/* N1-menu-ontwerp (04-10-2026): gedrag van het OnePod-menu (snippets/op-menu.liquid).
   - Desktop: Merken en Hulp openen met 110 ms vertraging bij de muis, met klik of Enter bij toetsenbord/tik;
     Escape sluit en zet de focus terug. Het merkenpaneel haalt de modellen van een merk op via
     /collections/<merk>?section_id=op-menu-merk (cache per merk).
   - Mobiel: lade met focusval, Escape, achtergrond inert en vast; een merk opent niveau 2 met een benoemde
     terugknop; "Alle 17 merken" klapt de rest van de lijst uit.
   Hoogte van de lade: --op-vh uit op-polish.js (iOS-fix van de winkelwagenlade). */
(function () {
  'use strict';
  var root = document.querySelector('[data-op-menu]');
  if (!root || root.__opMenu) return;
  root.__opMenu = true;

  var mq = window.matchMedia('(min-width: 1024px)');
  var lade = root.querySelector('#op-lade');
  var hamb = root.querySelector('[data-op-open]');
  var niv1 = root.querySelector('[data-op-niv1]');
  var niv2 = root.querySelector('[data-op-niv2]');
  var n2 = root.querySelector('[data-op-n2]');
  var terug = root.querySelector('[data-op-terug]');
  var mk = root.querySelector('[data-op-mk]');
  var md = root.querySelector('[data-op-md]');
  var mega = root.querySelector('.op-nav__item--mega');
  var overlay = document.querySelector('.js-overlay');
  var cache = {};
  var open = null, tOpen, tSluit, tMerk, n2Bron = null, hoverOpen = 0;
  var FOCUS = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function desk() { return mq.matches; }
  function knopVan(li) { return li.querySelector('.op-nav__top'); }
  function overlayAan(aan) {
    if (!overlay) return;
    overlay.classList.toggle('overlay--nav', aan);
    overlay.classList.toggle('is-visible', aan);
  }

  /* ---------- ophalen van één merk ---------- */
  function haal(href) {
    var u = href.split('#')[0];
    u += (u.indexOf('?') < 0 ? '?' : '&') + 'section_id=op-menu-merk';
    if (!cache[u]) {
      cache[u] = fetch(u, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (t) {
          var d = document.createElement('div');
          d.innerHTML = t;
          var el = d.querySelector('.op-mm');
          if (!el) throw new Error('geen merk');
          return el.outerHTML;
        })
        .catch(function (e) { delete cache[u]; throw e; });
    }
    return cache[u];
  }

  /* ---------- desktop ---------- */
  function merken() { return mk ? mk.querySelectorAll('[data-op-merk]') : []; }
  function huidigMerk() {
    return (mk && (mk.querySelector('.op-mk__merk.is-act') || mk.querySelector('[data-op-merk]'))) || null;
  }
  function toonMerk(a) {
    if (!md || !a) return;
    md.setAttribute('aria-busy', 'true');
    haal(a.href).then(function (html) {
      if (huidigMerk() === a) md.innerHTML = html;
    }, function () {
      if (huidigMerk() !== a) return;
      md.innerHTML = '<p class="op-md__fout"><a href="' + a.getAttribute('href') + '">Alles van ' + a.textContent.trim() + ' bekijken</a></p>';
    }).then(function () { md.removeAttribute('aria-busy'); });
  }
  function kiesMerk(a) {
    if (huidigMerk() === a && md && md.firstChild) return;
    merken().forEach(function (x) { x.classList.toggle('is-act', x === a); });
    toonMerk(a);
  }
  function zet(li, aan) {
    li.classList.toggle('is-open', aan);
    knopVan(li).setAttribute('aria-expanded', aan ? 'true' : 'false');
  }
  function openDesk(li) {
    clearTimeout(tSluit);
    if (open && open !== li) zet(open, false);
    open = li;
    zet(li, true);
    overlayAan(true);
    if (li === mega && md && !md.firstChild) kiesMerk(huidigMerk());
  }
  function sluitDesk(focusTerug) {
    clearTimeout(tOpen);
    if (!open) return;
    var li = open;
    open = null;
    zet(li, false);
    overlayAan(false);
    if (focusTerug) knopVan(li).focus();
  }

  root.querySelectorAll('[data-op-item]').forEach(function (li) {
    var knop = knopVan(li);
    li.addEventListener('pointerenter', function (e) {
      if (!desk() || e.pointerType !== 'mouse') return;
      clearTimeout(tSluit);
      if (li === mega) { var a = huidigMerk(); if (a) haal(a.href).catch(function () {}); }
      clearTimeout(tOpen);
      tOpen = setTimeout(function () { openDesk(li); hoverOpen = Date.now(); }, 110);
    });
    li.addEventListener('pointerleave', function (e) {
      if (!desk() || e.pointerType !== 'mouse') return;
      clearTimeout(tOpen);
      tSluit = setTimeout(function () { if (open === li) sluitDesk(false); }, 300);
    });
    knop.addEventListener('click', function () {
      if (!desk()) return;
      /* wie met de muis naar Merken gaat en klikt, klikt vlak nadat de hover het paneel opende: niet weer dichtklappen */
      if (open === li && Date.now() - hoverOpen < 1000) return;
      if (open === li) sluitDesk(false); else openDesk(li);
    });
    li.addEventListener('focusout', function (e) {
      if (desk() && open === li && e.relatedTarget && !li.contains(e.relatedTarget)) sluitDesk(false);
    });
  });

  if (mk) {
    mk.addEventListener('pointerover', function (e) {
      var a = e.target.closest('[data-op-merk]');
      if (!a || !desk() || e.pointerType !== 'mouse') return;
      clearTimeout(tMerk);
      tMerk = setTimeout(function () { kiesMerk(a); }, 110);
    });
    mk.addEventListener('focusin', function (e) {
      var a = e.target.closest('[data-op-merk]');
      if (a && desk()) kiesMerk(a);
    });
  }

  document.addEventListener('click', function (e) {
    if (open && !open.contains(e.target)) sluitDesk(false);
  });
  /* zoeken openen sluit het paneel (de zoeker van het thema gebruikt dezelfde overlay) */
  document.querySelectorAll('.js-toggle-search').forEach(function (el) {
    el.addEventListener('click', function () { if (open) { var li = open; open = null; zet(li, false); } });
  });

  /* ---------- mobiel: de lade ---------- */
  function ladeOpen() { return lade.classList.contains('is-open'); }
  function zichtbaar(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }
  function achtergrond(aan) {
    document.querySelectorAll('main, footer, .op-announcement-section, .header__grid > *').forEach(function (el) {
      if (el.contains(root)) return;
      if (aan) el.setAttribute('inert', ''); else el.removeAttribute('inert');
    });
    document.documentElement.classList.toggle('op-lade-open', aan);
  }
  function naarNiv1(focusEl) {
    if (!niv2.hidden) {
      niv2.hidden = true;
      niv1.hidden = false;
      lade.scrollTop = 0;
    }
    if (focusEl) focusEl.focus();
  }
  function openLade() {
    lade.classList.add('is-open');
    lade.setAttribute('role', 'dialog');
    lade.setAttribute('aria-modal', 'true');
    lade.setAttribute('aria-label', 'Menu');
    hamb.setAttribute('aria-expanded', 'true');
    achtergrond(true);
    overlayAan(true);
    naarNiv1();
    lade.scrollTop = 0;
    var s = lade.querySelector('[data-op-sluit]');
    if (s) s.focus();
  }
  function sluitLade(focusTerug) {
    if (!ladeOpen()) return;
    lade.classList.remove('is-open');
    lade.removeAttribute('role');
    lade.removeAttribute('aria-modal');
    lade.removeAttribute('aria-label');
    hamb.setAttribute('aria-expanded', 'false');
    achtergrond(false);
    overlayAan(false);
    if (location.hash === '#op-lade' && history.replaceState) history.replaceState(null, '', location.pathname + location.search);
    if (focusTerug !== false) hamb.focus();
  }
  function openNiv2(a) {
    n2Bron = a;
    niv1.hidden = true;
    niv2.hidden = false;
    lade.scrollTop = 0;
    n2.innerHTML = '<p class="op-n2__laden" role="status">' + a.textContent.trim() + ' laden&hellip;</p>';
    terug.focus();
    haal(a.href).then(function (html) {
      if (n2Bron !== a || niv2.hidden) return;
      n2.innerHTML = html;
      var h = n2.querySelector('.op-mm__naam');
      if (h) h.focus();
    }, function () { window.location.href = a.href; });
  }

  hamb.addEventListener('click', function (e) {
    e.preventDefault();
    if (ladeOpen()) sluitLade(); else openLade();
  });
  /* de menuknop is een link met role=button: ook de spatiebalk moet hem openen */
  hamb.addEventListener('keydown', function (e) {
    if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); hamb.click(); }
  });
  lade.addEventListener('click', function (e) {
    if (desk()) return;
    if (e.target.closest('[data-op-sluit]')) { sluitLade(); return; }
    var a = e.target.closest('[data-op-merk]');
    if (a) { e.preventDefault(); openNiv2(a); return; }
    var alle = e.target.closest('[data-op-alle]');
    if (alle && mk && !mk.classList.contains('is-alle')) {
      e.preventDefault();
      mk.classList.add('is-alle');
      var eerste = mk.querySelector('.op-mk__extra [data-op-merk]');
      if (eerste) eerste.focus();
    }
  });
  terug.addEventListener('click', function () { naarNiv1(n2Bron); });
  if (overlay) overlay.addEventListener('click', function () { sluitDesk(false); sluitLade(false); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      if (open) { e.preventDefault(); sluitDesk(true); return; }
      if (ladeOpen() && !desk()) {
        e.preventDefault();
        if (!niv2.hidden) naarNiv1(n2Bron); else sluitLade();
      }
      return;
    }
    if (e.key !== 'Tab' || !ladeOpen() || desk()) return;
    var els = Array.prototype.filter.call(lade.querySelectorAll(FOCUS), zichtbaar);
    if (!els.length) return;
    var eerste = els[0], laatste = els[els.length - 1];
    if (!lade.contains(document.activeElement)) { e.preventDefault(); eerste.focus(); }
    else if (e.shiftKey && document.activeElement === eerste) { e.preventDefault(); laatste.focus(); }
    else if (!e.shiftKey && document.activeElement === laatste) { e.preventDefault(); eerste.focus(); }
  });

  function wissel() {
    if (desk()) sluitLade(false); else sluitDesk(false);
  }
  if (mq.addEventListener) mq.addEventListener('change', wissel); else if (mq.addListener) mq.addListener(wissel);
})();
